import {
  CheckIcon,
  PencilIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import {
  Card,
  CardHeader,
  Typography,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
  Tabs,
  TabsHeader,
  Tab,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { dataGet, dataPost, dataPut } from "../../network";
import { updateStaus, userDeleteData, usersUrl } from "../../network/const";
import { AuthData } from "../../context/AuthWrapper";
import { Dialog } from "./Dialog";
import { dateFormat } from "../../include/Common";
import axios, { CancelToken } from "axios";
import { useNavigate } from "react-router-dom";
import { UserModel } from "../../network/dataType";
import { MessageDialog } from "./MessageDialog";
import { ApproveDialog } from "./ApproveDialog";
import { RejectDialog } from "./RejectDialog";

type TableProps = {
  TABLE_HEAD?: string[];
  Api?: string;
};
const TABS = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "100",
    value: 100,
  },
  {
    label: "500",
    value: 500,
  },
  {
    label: "All",
    value: -1,
  },
];

const TABLE_HEAD = [
  { name: "Id", class: " w-50 " },
  { name: "Name", class: " w-50" },
  { name: "email", class: "" },
  { name: "Role", class: " w-50" },
  { name: "Status", class: " w-50" },
  { name: "CreatedAt", class: "w-72" },
  { name: "Details", class: "" },
];

// eslint-disable-next-line no-empty-pattern
export const UsersTable: React.FC<TableProps> = ({}) => {
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageLinks, setPageLinks] = useState<number[]>([]);
  const [view, setView] = useState(false);
  const [alertDialogStatus, setAlertDialogSlatus] = useState(false);
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserModel | null>(null);

  type dialog = {
    title: string;
    description: any;
    btnText: string;
    data: any;
  };
  type dialogAlert = {
    title: string;
    description: any;
    btnText: string;
  };
  const [dialogData, setDialogData] = useState<dialog>({
    description: "",
    title: "",
    btnText: "",
    data: "",
  });
  const [alertDialogData, setAlertDialogData] = useState<dialogAlert>({
    description: "",
    title: "",
    btnText: "",
  });
  const [TABLE_ROWS, setTABLEROWS] = useState<UserModel[]>([]);
  const authData = AuthData();
  // const TABLE_HEAD = ;
  const fetchData = async (source: CancelToken) => {
    const data = await dataGet(
      usersUrl,
      {
        page: page,
        perPage: perPage,
      },
      source
    );
    if (data.status) {
      if (data.data.rows) {
        setTABLEROWS(data.data.rows);
        setTotalPages(data.data.totalPages);
        pageLinksFun(data.data.totalPages);
      } else {
        setTotalPages(0);
      }
    } else {
      authData?.setError({
        error: true,
        errorDescription: data.message,
        errorTitle: data.title,
        errorType: "error",
        hide: data.hide,
        code: data.code,
      });
    }
  };

  const deleteFunction = async (row: string) => {
    const url = userDeleteData + "/" + row;
    const data = await dataPost(url, {});
    if (data.status) {
      setRefresh(Math.random().toString());
      setAlertDialogSlatus(true);

      setAlertDialogData({
        title: data.title,
        description: data.message,
        btnText: "Ok",
      });
    } else {
      setAlertDialogSlatus(true);
      setAlertDialogData({
        title: data.title,
        description: data.message,
        btnText: "Ok",
      });
    }
  };

  const handleApprove = async () => {
    if (!selectedUser) return;
    const payload = {
      id: selectedUser.id, // get the id from selectedUser
      roleStatus: "Approved",
    };
    setApproveDialogOpen(false);
    const data = await dataPut(updateStaus, payload, { silent: false });

    setSelectedUser(null);
    setAlertDialogSlatus(true);
    setAlertDialogData({
      title: data.title,
      description: (
        <>
          <p>{data.message}</p>
          <p>User Name: {data.data?.fullName || "-"}</p>
          <p>User Email: {data.data?.email || "-"}</p>
          <p>Status: {data.data?.status || "-"}</p>
        </>
      ),
      btnText: "Ok",
    });
    if (data.status) setRefresh(Math.random().toString());
  };

  const handleReject = async (reason: string) => {
    if (!selectedUser) return;
    const payload = {
      id: selectedUser.id, // get the id from selectedUser
      roleStatus: "Rejected",
      rejectionReason: reason,
    };
    setRejectDialogOpen(false);
    const data = await dataPut(updateStaus, payload, { silent: false });

    setSelectedUser(null);
    setAlertDialogSlatus(true);
    setAlertDialogData({
      title: data.title,
      description: (
        <>
          <p>{data.message}</p>
          <p>User Name: {data.data?.fullName || "-"}</p>
          <p>User Email: {data.data?.email || "-"}</p>
          <p>Status: {data.data?.status || "-"}</p>
        </>
      ),
      btnText: "Ok",
    });
    if (data.status) setRefresh(Math.random().toString());
  };

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    fetchData(source.token);

    return () => {
      source.cancel("Component is unmounted"); // Cancel the request when the component is unmounted
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, refresh]);

  const pageLinksFun = (totalPage: number, showingLinks: number = 4) => {
    let i = 1;
    const limit: number = showingLinks / 2;
    const minLimit = page - limit <= 0 ? 1 : page - limit;
    const balance = minLimit < limit ? limit + minLimit : 0;
    let maxLimit =
      minLimit + limit + balance >= totalPage
        ? totalPage
        : minLimit + limit + balance;

    let pages = [];
    for (i = minLimit; i <= maxLimit; i++) pages.push(i);
    setPageLinks(pages);
  };

  return (
    <>
      <Card className="h-full w-full">
        <CardHeader floated={false} shadow={false} className="rounded-none h-">
          <div className="mb-4 flex flex-col justify-between gap-8 md:flex-row md:items-center">
            <div>
              <Tabs value={perPage} className="w-full md:w-max">
                <TabsHeader>
                  {TABS.map(({ label, value }) => (
                    <Tab
                      key={value}
                      value={value}
                      onClick={(e) => {
                        setPage(1);
                        setPerPage(value);
                      }}
                    >
                      {label}
                    </Tab>
                  ))}
                </TabsHeader>
              </Tabs>
            </div>
            <div className="flex w-full shrink-0 gap-2 md:w-max">
              <Button
                color="green"
                variant="gradient"
                onClick={() => {
                  navigate("/user-manage");
                }}
              >
                <span>Add User</span>
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-0">
          <table className="w-full min-w-max table-auto text-left break-all  whitespace-break-spaces">
            <thead>
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th
                    key={head.name}
                    className={`border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 ${head.class}`}
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="font-normal leading-none opacity-70 "
                    >
                      {head.name}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {TABLE_ROWS.length ? (
                TABLE_ROWS.map((row, index) => {
                  const { id, username, email, role, roleStatus, createdAt } =
                    row;
                  const isLast = index === TABLE_ROWS.length - 1;
                  const classes = isLast
                    ? "p-4"
                    : "p-4 border-b border-blue-gray-50";

                  return (
                    <tr key={id}>
                      <td className={classes}>
                        <div className="flex items-center gap-3">
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-bold"
                          >
                            {id}
                          </Typography>
                        </div>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {username}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {email}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {role}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {roleStatus}
                        </Typography>
                      </td>
                      <td className={classes}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {dateFormat(createdAt)}
                        </Typography>
                      </td>
                      <td className={classes}>
                        {/* Conditionally show Approve/Reject buttons */}
                        {role === "User" && roleStatus === "Pending" && (
                          <>
                            <Tooltip content="Approve">
                              <IconButton
                                className="bg-green-200 m-1"
                                onClick={() => {
                                  setSelectedUser(row);
                                  setView(true);
                                  setApproveDialogOpen(true);
                                }}
                              >
                                <CheckIcon className="h-4 w-4 text-green-600" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip content="Reject">
                              <IconButton
                                className="bg-red-200 m-1"
                                onClick={() => {
                                  setView(true);
                                  setSelectedUser(row);
                                  setRejectDialogOpen(true);
                                }}
                              >
                                <XCircleIcon className="h-5 w-5 text-red-600" />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}

                        {/* Always show Edit/Delete */}
                        <Tooltip content="Edit">
                          <IconButton
                            variant="text"
                            className="border bg-cyan-400  m-1"
                            onClick={() => {
                              navigate("/user-manage", {
                                state: row,
                              });
                            }}
                          >
                            <PencilIcon className="h-4 w-4" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip content="Delete">
                          <IconButton
                            variant="text"
                            className="border bg-red-200  "
                            onClick={() => {
                              setView(true);
                              setDialogData({
                                title: "Delete",
                                btnText: "Yes",
                                description: `Do you want to delete ${row.username}`,
                                data: row.id,
                              });
                            }}
                          >
                            <TrashIcon className="h-4 w-4" />
                          </IconButton>
                        </Tooltip>
                      </td>

                      {/* <td className={classes}>
                        <Tooltip content="Edit">
                          <IconButton
                            variant="text"
                            className="border bg-cyan-400  m-1"
                            onClick={() => {
                              navigate("/user-manage", {
                                state: row,
                              });
                            }}
                          >
                            <PencilIcon className="h-4 w-4" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip content="Delete">
                          <IconButton
                            variant="text"
                            className="border bg-red-200  "
                            onClick={() => {
                              setView(true);
                              setDialogData({
                                title: "Delete",
                                btnText: "Yes",
                                description: `Do you want to delete ${row.username}`,
                                data: row.id,
                              });
                            }}
                          >
                            <TrashIcon className="h-4 w-4" />
                          </IconButton>
                        </Tooltip>
                      </td> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td className=" text-center" colSpan={6}>
                    Empty Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
        <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
          <Button
            variant="outlined"
            size="sm"
            onClick={() => setPage((prev) => (prev === 1 ? 1 : prev - 1))}
          >
            Previous
          </Button>
          <div className="flex items-center gap-2">
            {pageLinks.map((e) => {
              return (
                <IconButton
                  variant="outlined"
                  size="sm"
                  className={`${page === e ? "bg-blue-gray-100" : ""}`}
                  onClick={() => setPage(e)}
                >
                  {e}
                </IconButton>
              );
            })}
          </div>
          <Button
            variant="outlined"
            size="sm"
            onClick={() =>
              setPage((prev) => (prev === totalPages ? totalPages : prev + 1))
            }
          >
            Next
          </Button>
        </CardFooter>
      </Card>
      <MessageDialog
        open={view}
        handleOpen={() => {
          setView(!view);
        }}
        handleClose={() => {
          setView(!view);
        }}
        handleConfirm={() => {
          deleteFunction(dialogData.data);
          setView(!view);
        }}
        description={dialogData.description}
        title={dialogData.title}
        succesBtn={dialogData.btnText}
        succesBtnClass={""}
        cancelBtn={"Cancel"}
        cancelBtnClass={"bg-red-200"}
        size="sm"
      />
      <Dialog
        open={alertDialogStatus}
        handleOpen={() => {
          setAlertDialogSlatus(!alertDialogStatus);
        }}
        title={alertDialogData.title}
        description={alertDialogData.description}
        buttonText={"Ok"}
      />
      {selectedUser && (
        <>
          <ApproveDialog
            open={approveDialogOpen}
            onClose={() => setApproveDialogOpen(false)}
            onConfirm={handleApprove}
            username={selectedUser.username}
          />
          <RejectDialog
            open={rejectDialogOpen}
            onClose={() => setRejectDialogOpen(false)}
            onConfirm={handleReject}
            username={selectedUser.username}
          />
        </>
      )}
    </>
  );
};
